import { CLASSES, type ProgressView, UNLOCKS } from '@xox/shared'
import { Flame, Sparkles } from 'lucide-react'
import { Card } from './ui'

/** Account level, XP bar, daily streak and the next thing that unlocks. */
export function ProgressCard({ progress }: { progress: ProgressView }) {
  const next = UNLOCKS.find((u) => u.level > progress.level)
  const pct = Math.round((progress.levelXp / progress.nextLevelXp) * 100)
  return (
    <Card className="flex flex-col gap-2">
      <div className="flex items-baseline justify-between gap-2">
        <h2 className="font-semibold">
          <Sparkles className="mr-1 inline size-4 text-sky-500" aria-hidden />
          Level {progress.level}{' '}
          <span className="text-sm font-normal text-slate-500">· {progress.title}</span>
        </h2>
        {progress.streak > 0 && (
          <span className="inline-flex items-center gap-1 text-sm font-semibold text-orange-600">
            <Flame className="size-4" aria-hidden /> {progress.streak}-day streak
          </span>
        )}
      </div>
      <div
        className="h-2 overflow-hidden rounded-full bg-slate-200 dark:bg-slate-800"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={progress.nextLevelXp}
        aria-valuenow={progress.levelXp}
        aria-label="Progress to the next level"
      >
        <div
          className="h-full rounded-full bg-sky-500 transition-[width] duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="text-xs tabular-nums text-slate-500">
        {progress.levelXp} / {progress.nextLevelXp} XP
        {next && ` · ${CLASSES[next.cls].name} unlocks at level ${next.level}`}
      </p>
    </Card>
  )
}
